module.exports = __webpack_public_path__ + "img/coins-bg-hen.9b8c22af.png";